import { render, staticRenderFns } from "./LanguageSelectionButton.vue?vue&type=template&id=16af73f7&scoped=true&"
import script from "./LanguageSelectionButton.vue?vue&type=script&lang=js&"
export * from "./LanguageSelectionButton.vue?vue&type=script&lang=js&"
import style0 from "./LanguageSelectionButton.vue?vue&type=style&index=0&id=16af73f7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16af73f7",
  null
  
)

export default component.exports